import { PATHWAY } from "@/constants/testIds";
import { OPERATIONAL_DEBT } from "@/lib/pathwayData";
import { SectionEyebrow } from "@/components/pathway/Journey";

const toneBar = {
  ok: "bg-amber-600",
  warn: "bg-[#dc2626]",
  muted: "bg-neutral-500",
};

export default function OperationalDebt() {
  return (
    <section
      data-testid={PATHWAY.operationalDebt}
      className="border-t hairline bg-[#0f0f0f]"
    >
      <div className="mx-auto max-w-7xl px-6 py-24 md:px-12 md:py-28">
        <div className="grid gap-8 md:grid-cols-[1.2fr_1fr] md:items-end md:gap-16">
          <div>
            <SectionEyebrow>Operational debt</SectionEyebrow>
            <h2 className="mt-4 font-serif text-3xl leading-tight tracking-tight text-neutral-50 sm:text-4xl">
              Volume without governance compounds operational debt.
            </h2>
          </div>
          <p className="text-neutral-400">
            AI accelerates volume. Governance keeps each decision attributable.
            Without runtime governance, the gap between volume and accountability
            becomes operational debt — and it compounds.
          </p>
        </div>

        <div className="mt-14 grid grid-cols-1 gap-0 border-l hairline md:grid-cols-2">
          {OPERATIONAL_DEBT.states.map((s) => (
            <article
              key={s.slug}
              data-testid={PATHWAY.debtState(s.slug)}
              className="border-b border-r hairline p-8 md:p-10"
            >
              <div className="font-mono text-[10px] uppercase tracking-[0.28em] text-neutral-500">
                {s.label}
              </div>
              <p className="mt-3 text-[14px] leading-relaxed text-neutral-300">
                {s.caption}
              </p>

              <div className="mt-8 space-y-5">
                {s.bars.map((b) => (
                  <div
                    key={b.slug}
                    data-testid={PATHWAY.debtBar(s.slug, b.slug)}
                  >
                    <div className="flex items-baseline justify-between">
                      <span className="font-mono text-[10px] uppercase tracking-[0.24em] text-neutral-400">
                        {b.label}
                      </span>
                      <span className="font-mono text-[11px] text-neutral-500">
                        {b.value}%
                      </span>
                    </div>
                    <div className="mt-2 h-2 w-full border hairline">
                      <div
                        className={`h-full ${
                          toneBar[b.tone] || "bg-neutral-300"
                        }`}
                        style={{ width: `${b.value}%` }}
                      />
                    </div>
                  </div>
                ))}
              </div>
            </article>
          ))}
        </div>

        <div className="mt-8 border-t hairline pt-5 font-mono text-[10px] uppercase tracking-[0.24em] text-neutral-500">
          Illustrative · synthetic indicators. One picture, two operating regimes.
        </div>
      </div>
    </section>
  );
}
